// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme, CircularProgress, Toolbar, Box } from '@mui/material';

import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Historial from './pages/historial';
import ChangePasswordPage from './pages/ChangePasswordPage';

// Ruta protegida simple
const ProtectedRoute = ({ children, auth }) => (auth ? children : <Navigate to="/login" replace />);

export default function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem('token');
    const nombre = localStorage.getItem('nombre');
    return !!(token && nombre);
  });
  const [loading, setLoading] = useState(true);



  const perfil = (localStorage.getItem('perfil') || '').toLowerCase();
  const isAdmin = perfil === 'admin' || perfil === 'administrador';

  // Verifica auth al montar y escucha cambios de storage (multi-pestaña)
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const nombre = localStorage.getItem('nombre');
      setAuth(!!(token && nombre));
    };
    checkAuth();
    setLoading(false);

    const onStorage = (e) => {
      if (e.key === 'token' || e.key === 'nombre') checkAuth();
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: { main: '#4CAF50' } // ajusta si prefieres el azul del sidebar
    }
  });

  const handleLoginSuccess = () => {
    const token = localStorage.getItem('token');
    const nombre = localStorage.getItem('nombre');
    if (token && nombre) setAuth(true);
  };
  

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('nombre');
    setAuth(false);
  };

  // Spinner inicial
  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </div>
      </ThemeProvider>
    );
  }

  // Layout para páginas protegidas (incluye Sidebar y el espaciador <Toolbar /> del AppBar)
  const ProtectedShell = ({ children }) => (
    <div style={{ display: 'flex' }}>
      <Sidebar
        toggleTheme={() => setDarkMode((v) => !v)}
        onLogout={handleLogout}
        darkMode={darkMode}
        isAuthenticated={auth}
        isAdminUser={isAdmin} 
      />
      <main style={{ flexGrow: 1, padding: 20 }}>
        {/* Este Toolbar empuja el contenido por debajo del AppBar fijo del Sidebar */}
        <Toolbar />
        {children}
      </main>
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Login libre, redirige si ya está autenticado */}
          <Route
            path="/login"
            element={auth ? <Navigate to="/" replace /> : <LoginPage onLoginSuccess={handleLoginSuccess} />}
          />

          {/* Registro */}
          <Route
            path="/registro"
            element={
              <ProtectedRoute auth={auth}>
                <ProtectedShell>
                  <RegisterPage />
                </ProtectedShell>
              </ProtectedRoute>
            }
          />

          {/* Inicio */}
          <Route
            path="/"
            element={
              <ProtectedRoute auth={auth}>
                <ProtectedShell>
                  <HomePage />
                </ProtectedShell>
              </ProtectedRoute>
            }
          />

          {/* Historial Médico */}
          <Route
            path="/historial"
            element={
              <ProtectedRoute auth={auth}>
                <ProtectedShell>
                  <Historial />
                </ProtectedShell>
              </ProtectedRoute>
            }
          />

          {/* Cambiar contraseña */}
          <Route
            path="/cambiar-clave"
            element={
              <ProtectedRoute auth={auth}>
                <ProtectedShell>
                  <ChangePasswordPage />
                </ProtectedShell>
              </ProtectedRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to={auth ? '/' : '/login'} replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
